import styled from 'styled-components';
import { media } from 'settings/style';

export const EventListWrapper = styled.div`
  padding: 0 0 1.5rem;
  flex: 1;
  min-width: 0;
  width: 100%;
  background: #ffffff;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;

  ${media.md`
    padding: 0 0 1rem;
  `}
`;
